export const INVALID_DATE_TEXT = 'Invalid Date';
export const DISPLAY_FORMAT = 'MM/dd/yyyy';
export const DEFAULT_FORMAT = 'yyyy-MM-dd';
export const UNIVERSAL_FORMAT = 'dd-MMM-yyyy';
export const FULL_DATE_FORMAT = 'EEEE, MMMM d, yyyy';
